module.exports = __webpack_public_path__ + "static/media/1@3x.97d8ccd0.png";